import { Label } from "reactstrap";
import { MonthInputField } from "../../../../CommonElements";
import { getDateToday } from "../../../../Utils/externalFunctions";

const AbsenStafFilterComponent = ({ updateMonthFilter, periode }) => {
  return (
    <div className={"w-100 row row-cols-6 align-items-center"}>
      <Label className={"m-0 col"}>Periode</Label>

      <MonthInputField
        // label={"Bulan"}
        className={"m-0 col-3"}
        onChange={(e) => updateMonthFilter(e.target.value)}
        defaultValue={periode || getDateToday("original").substring(0, 7)}
      />
    </div>
  );
};

export default AbsenStafFilterComponent;
